import { render } from "./AudioResourceManagement.vue?vue&type=template&id=2a50f9a9&scoped=true"
import script from "./AudioResourceManagement.vue?vue&type=script&lang=js"
export * from "./AudioResourceManagement.vue?vue&type=script&lang=js"

import "./AudioResourceManagement.vue?vue&type=style&index=0&id=2a50f9a9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a50f9a9"]])

export default __exports__